/* SEO taxonomy for Motravay — synthesised from Mr Cravatte SEO Architect spec.
   Each category carries: bilingual labels, alias terms (used for matching jobs
   to the landing page), and a tight Mr Cravatte marketing snippet for the H2. */

export const CATEGORIES = [
  {
    slug: "it",
    label_en: "ICT, Tech & Digital",
    label_fr: "Informatique, Tech & Digital",
    en_kw: "ICT & Tech",
    fr_kw: "Informatique & Tech",
    aliases: [
      "it", "ict", "tech", "software", "developer", "developpeur", "développeur",
      "informatique", "data", "analyst", "devops", "cybersecurity", "réseau", "reseau",
      "ingénieur informatique", "ingenieur informatique", "web", "mobile", "qa", "tester",
      "cybercity", "ebene", "ebène",
    ],
    cravatte_en: "Mauritius' top ICT employers source their elite engineers, devs and cybersecurity leads here — the shortest path between Ebene Cybercity and your next role.",
    cravatte_fr: "Les meilleurs employeurs IT de Maurice trouvent leurs développeurs, ingénieurs et experts cybersécurité ici — le chemin le plus court entre l'Ebene Cybercity et votre prochain poste.",
  },
  {
    slug: "finance",
    label_en: "Banking, Finance & Global Business",
    label_fr: "Banque, Finance & Global Business",
    en_kw: "Finance & Accounting",
    fr_kw: "Finance & Comptabilité",
    aliases: [
      "finance", "banking", "bank", "banque", "accounting", "accountant", "comptable",
      "comptabilité", "comptabilite", "audit", "auditor", "fund", "compliance", "treasury",
      "acca", "tax", "fiscaliste", "global business", "offshore", "fintech",
      "fund administrator", "gestionnaire de fonds",
    ],
    cravatte_en: "Mauritius is the offshore financial hub of the Indian Ocean. Discover the country's most demanding fund admin, audit, ACCA and compliance briefs — only on Motravay.",
    cravatte_fr: "Maurice est le hub financier offshore de l'océan Indien. Découvrez les postes les plus exigeants en audit, fund administration, ACCA et compliance — uniquement sur Motravay.",
  },
  {
    slug: "hospitality",
    label_en: "Tourism & Hospitality",
    label_fr: "Tourisme & Hôtellerie",
    en_kw: "Hospitality & Tourism",
    fr_kw: "Hôtellerie & Tourisme",
    aliases: [
      "hospitality", "hotel", "hotellerie", "hôtellerie", "tourism", "tourisme",
      "resort", "réceptionniste", "receptionniste",
      "housekeeping", "concierge", "tour operator", "guide", "guest relations",
      "front office", "reservations", "revenue manager",
    ],
    cravatte_en: "From Grand Baie to Le Morne, every 5-star resort on the island recruits through Motravay. The fastest route from rising hospitality talent to corner-office hospitality leadership.",
    cravatte_fr: "De Grand Baie au Morne, chaque resort 5 étoiles de l'île recrute via Motravay. La voie la plus rapide entre les talents émergents et les postes de direction dans l'hôtellerie.",
  },
  {
    slug: "restauration",
    label_en: "Food Service & Restaurants",
    label_fr: "Restauration & F&B",
    en_kw: "Food Service & F&B",
    fr_kw: "Restauration & F&B",
    aliases: [
      "restaurant", "restauration", "f&b", "fnb", "food and beverage",
      "chef", "cuisinier", "cuisiniere", "cuisinière", "commis", "sous chef", "chef de partie",
      "pastry", "pâtissier", "patissier", "boulanger", "boulangerie", "baker",
      "waiter", "waitress", "serveur", "serveuse", "barman", "bartender", "barista",
      "runner", "hostess", "hôte", "maitre d'hotel", "maître d'hôtel", "sommelier",
      "kitchen", "cuisine", "brasserie", "bistro", "café", "cafe", "caterer", "catering", "traiteur",
    ],
    cravatte_en: "From beach-shack kitchens to Michelin-inspired resort brigades, the island's most demanding chefs, sommeliers and F&B managers recruit on Motravay.",
    cravatte_fr: "Des cuisines de plage aux brigades inspirées Michelin, les chefs, sommeliers et responsables F&B les plus exigeants de l'île recrutent sur Motravay.",
  },
  {
    slug: "bpo",
    label_en: "BPO, Customer Service & Shared Services",
    label_fr: "BPO & Service Client",
    en_kw: "BPO & Customer Service",
    fr_kw: "BPO & Service Client",
    aliases: [
      "bpo", "call center", "callcenter", "centre d'appel", "centre d appel",
      "customer service", "customer care", "service client", "conseiller client",
      "teleagent", "téléagent", "teleconseiller", "téléconseiller",
      "support", "helpdesk", "french speaking",
    ],
    cravatte_en: "Mauritius' BPO sector is the silent engine behind half of Francophone Europe's customer service. Land the right desk in a Tier-1 contact centre — today.",
    cravatte_fr: "Le secteur BPO mauricien est le moteur silencieux du service client francophone. Décrochez le bon poste dans un centre Tier-1 — aujourd'hui.",
  },
  {
    slug: "sales",
    label_en: "Retail, Sales & Marketing",
    label_fr: "Commerce, Vente & Marketing",
    en_kw: "Sales & Marketing",
    fr_kw: "Vente & Marketing",
    aliases: [
      "sales", "vente", "commercial", "marketing", "digital marketing",
      "retail", "store manager", "responsable magasin", "boutique", "magasin",
      "caissier", "cashier", "merchandiser", "business development",
    ],
    cravatte_en: "Top retail chains, FMCG giants and digital marketing agencies in Mauritius post their highest-stake commercial mandates here.",
    cravatte_fr: "Les grandes enseignes, géants FMCG et agences marketing de Maurice publient ici leurs mandats commerciaux les plus stratégiques.",
  },
  {
    slug: "transport",
    label_en: "Logistics, Supply Chain & Transport",
    label_fr: "Logistique, Supply Chain & Transport",
    en_kw: "Logistics & Transport",
    fr_kw: "Logistique & Transport",
    aliases: [
      "logistics", "logistique", "supply chain", "chaine logistique", "chaîne logistique",
      "shipping", "freight", "warehouse", "magasinier", "warehouse operator",
      "driver", "chauffeur", "livreur", "delivery", "transport", "fleet",
    ],
    cravatte_en: "Mauritius is the strategic shipping bridge of the Indian Ocean — find the logistics, shipping and supply-chain roles that move the island's economy.",
    cravatte_fr: "Maurice est le pont stratégique de l'océan Indien — trouvez les postes en logistique, transport maritime et supply chain qui font tourner l'économie.",
  },
  {
    slug: "construction",
    label_en: "Construction, Real Estate & Engineering",
    label_fr: "Construction, Immobilier & Ingénierie",
    en_kw: "Construction & Engineering",
    fr_kw: "Construction & Ingénierie",
    aliases: [
      "construction", "civil engineer", "ingénieur civil", "ingenieur civil",
      "quantity surveyor", "site supervisor", "conducteur de travaux",
      "real estate", "immobilier", "agent immobilier", "architect", "architecte",
      "macon", "maçon", "engineering", "ingénierie", "ingenierie",
    ],
    cravatte_en: "Smart-city developments, luxury IRS villas, large-scale infrastructure — Mauritius' construction sector is booming and these are its top engineering briefs.",
    cravatte_fr: "Smart cities, villas IRS de luxe, infrastructures à grande échelle — la construction mauricienne est en plein boom, voici ses meilleurs mandats d'ingénierie.",
  },
  {
    slug: "manufacturing",
    label_en: "Manufacturing, Textile & Production",
    label_fr: "Industrie, Textile & Production",
    en_kw: "Manufacturing & Production",
    fr_kw: "Industrie & Production",
    aliases: [
      "factory", "usine", "production", "manufacturing", "industrie",
      "maintenance", "technicien de maintenance", "operateur d'usine", "opérateur d'usine",
      "textile", "couturier", "couturière", "garment", "chef de production",
    ],
    cravatte_en: "From Riche Terre to Coromandel, the country's manufacturing leaders trust Motravay to staff their production floors and maintenance teams.",
    cravatte_fr: "De Riche Terre à Coromandel, les leaders industriels du pays confient à Motravay le recrutement de leurs équipes de production et de maintenance.",
  },
  {
    slug: "healthcare",
    label_en: "Healthcare, Medical & Wellness",
    label_fr: "Santé, Médical & Bien-être",
    en_kw: "Healthcare",
    fr_kw: "Santé",
    aliases: [
      "nurse", "infirmier", "infirmière", "medical", "médical", "doctor", "médecin", "medecin",
      "pharma", "pharmacy", "pharmacien", "pharmacienne", "clinic", "clinique", "hospital",
      "hôpital", "wellness", "spa therapist", "delegue medical", "délégué médical",
    ],
    cravatte_en: "Private clinics, leading pharma groups and high-end wellness centres recruit Mauritius' top nurses, doctors and pharmacists exclusively on Motravay.",
    cravatte_fr: "Cliniques privées, groupes pharmaceutiques et centres de bien-être haut de gamme recrutent les meilleurs soignants de Maurice exclusivement sur Motravay.",
  },
  {
    slug: "education",
    label_en: "Education, Training & Academia",
    label_fr: "Éducation, Formation & Académique",
    en_kw: "Education",
    fr_kw: "Éducation",
    aliases: [
      "teacher", "professeur", "enseignant", "enseignante", "instituteur", "institutrice",
      "lecturer", "tutor", "tuteur", "education", "éducation", "training", "formation",
      "academic", "académique",
    ],
    cravatte_en: "From international schools in Phoenix to universities in Réduit, the island's most ambitious academic employers post here first.",
    cravatte_fr: "Des écoles internationales de Phoenix aux universités de Réduit, les employeurs académiques les plus ambitieux de l'île publient ici en priorité.",
  },
  {
    slug: "admin",
    label_en: "Management, HR, Legal & Administration",
    label_fr: "Management, RH, Juridique & Administration",
    en_kw: "Admin, HR & Legal",
    fr_kw: "Admin, RH & Juridique",
    aliases: [
      "admin", "administration", "administrative assistant", "assistant administratif",
      "hr", "human resources", "rh", "ressources humaines", "hr manager", "talent acquisition",
      "secretary", "secrétaire", "receptionist", "réceptionniste",
      "legal", "juriste", "lawyer", "avocat", "compliance officer",
    ],
    cravatte_en: "The backbone of every Mauritian business. Senior HR mandates, in-house counsel briefs and executive assistant openings — curated daily.",
    cravatte_fr: "L'épine dorsale de toute entreprise mauricienne. Postes RH seniors, briefs juridiques in-house et assistants de direction — curatés au quotidien.",
  },
  {
    slug: "blue-economy",
    label_en: "Blue Economy, Maritime & Agriculture",
    label_fr: "Économie Bleue, Maritime & Agriculture",
    en_kw: "Maritime & Agriculture",
    fr_kw: "Maritime & Agriculture",
    aliases: [
      "maritime", "marine", "seaman", "skipper", "skippeur", "captain", "capitaine",
      "agriculture", "agronome", "horticulture", "blue economy", "économie bleue", "economie bleue",
      "aquaculture", "pêche", "peche", "fisheries",
    ],
    cravatte_en: "The blue economy is Mauritius' next billion-rupee story. Maritime, aquaculture, agronomy and fisheries — explore the briefs powering it.",
    cravatte_fr: "L'économie bleue est la prochaine grande histoire de Maurice. Maritime, aquaculture, agronomie et pêche — explorez les mandats qui la portent.",
  },
  {
    slug: "delivery",
    label_en: "Delivery, Ride-hailing & Courier",
    label_fr: "Livraison, VTC & Coursier",
    en_kw: "Delivery & Ride-hailing",
    fr_kw: "Livraison & VTC",
    aliases: [
      "delivery", "livraison", "livreur", "courier", "coursier", "rider",
      "ride hailing", "ride-hailing", "vtc", "chauffeur vtc", "uber", "yango",
      "food delivery", "livraison repas", "last mile", "dernier kilomètre",
    ],
    cravatte_en: "As Mauritius' on-demand economy explodes, delivery riders, courier fleets and ride-hailing drivers are the new backbone. Land the top pay-per-drop briefs here.",
    cravatte_fr: "Alors que l'économie à la demande explose à Maurice, livreurs, coursiers et chauffeurs VTC sont la nouvelle colonne vertébrale. Trouvez les meilleurs mandats ici.",
  },
  {
    slug: "beauty",
    label_en: "Beauty, Wellness & Personal Care",
    label_fr: "Beauté, Bien-être & Soins",
    en_kw: "Beauty & Wellness",
    fr_kw: "Beauté & Bien-être",
    aliases: [
      "beauty", "beaute", "beauté", "salon", "coiffeur", "coiffeuse", "hairdresser", "hairstylist",
      "makeup", "maquilleur", "maquilleuse", "esthéticienne", "estheticienne", "esthetician",
      "spa", "spa therapist", "massage", "masseur", "masseuse", "nail", "manucure", "onglerie",
      "wellness", "bien-etre", "bien-être", "barber", "barbier",
    ],
    cravatte_en: "From high-end resort spas to Grand Baie salons, beauty, wellness and personal-care employers hire their most sought-after therapists and stylists on Motravay.",
    cravatte_fr: "Des spas de resorts haut de gamme aux salons de Grand Baie, les employeurs beauté, bien-être et soins recrutent leurs thérapeutes et stylistes les plus recherchés sur Motravay.",
  },
  {
    slug: "media",
    label_en: "Media, Creative & Communication",
    label_fr: "Médias, Créatif & Communication",
    en_kw: "Media & Creative",
    fr_kw: "Médias & Créatif",
    aliases: [
      "media", "média", "medias", "médias", "creative", "créatif", "creatif",
      "graphic designer", "designer graphique", "designer", "illustrator", "illustrateur",
      "photographer", "photographe", "videographer", "vidéaste", "video editor", "monteur",
      "journalist", "journaliste", "editor", "rédacteur", "redacteur", "content creator",
      "community manager", "cm", "social media", "communication", "pr", "public relations",
      "copywriter", "copywriting", "brand", "advertising", "publicité", "publicite",
    ],
    cravatte_en: "Agencies, newsrooms and in-house brand studios of Mauritius post their sharpest creative, editorial and communications briefs on Motravay.",
    cravatte_fr: "Agences, rédactions et studios de marque de Maurice publient sur Motravay leurs mandats créatifs, éditoriaux et communication les plus pointus.",
  },
  {
    slug: "public-sector",
    label_en: "Government, NGO & Public Sector",
    label_fr: "Public, ONG & Secteur Étatique",
    en_kw: "Government & NGO",
    fr_kw: "Public & ONG",
    aliases: [
      "government", "gouvernement", "public sector", "secteur public", "state", "état", "etat",
      "civil service", "fonctionnaire", "fonction publique", "ministry", "ministère", "ministere",
      "parastatal", "parastatale", "council", "municipal", "district council",
      "ngo", "ong", "non-profit", "nonprofit", "association", "asbl", "charity", "foundation", "fondation",
      "un ", "united nations", "nations unies", "development", "développement", "developpement",
    ],
    cravatte_en: "Ministries, parastatals and international NGOs shape Mauritius' public mission — discover the briefs driving policy, community and impact.",
    cravatte_fr: "Ministères, parastatales et ONG internationales façonnent la mission publique de Maurice — découvrez les mandats qui portent politique, communauté et impact.",
  },
];

// Hyper-local geographic taxonomy — full Mauritian districts + cities + sub-localities.
// Each entry can be referenced as /jobs/location/:slug OR /jobs/in-:slug (alias).
export const CITIES = [
  // Plaines Wilhems
  { slug: "ebene", label: "Ebène", region: "Plaines Wilhems", aliases: ["ebene", "ebène", "cybercity", "ebene cybercity"] },
  { slug: "quatre-bornes", label: "Quatre-Bornes", region: "Plaines Wilhems", aliases: ["quatre bornes", "quatre-bornes"] },
  { slug: "curepipe", label: "Curepipe", region: "Plaines Wilhems", aliases: ["curepipe"] },
  { slug: "rose-hill", label: "Rose-Hill", region: "Plaines Wilhems", aliases: ["rose hill", "rose-hill", "beau-bassin", "beau bassin"] },
  { slug: "vacoas", label: "Vacoas", region: "Plaines Wilhems", aliases: ["vacoas", "phoenix"] },
  { slug: "plaines-wilhems", label: "Plaines Wilhems", region: "Plaines Wilhems", aliases: ["plaines wilhems", "plaines-wilhems"] },

  // Port Louis (district = capital)
  { slug: "port-louis", label: "Port-Louis", region: "Port Louis", aliases: ["port louis", "port-louis", "les pailles", "roche bois", "tranquebar"] },

  // Moka (district)
  { slug: "moka", label: "Moka", region: "Moka", aliases: ["moka", "saint pierre", "saint-pierre", "alma", "réduit", "reduit"] },

  // Pamplemousses (district) — The North
  { slug: "grand-baie", label: "Grand Baie", region: "Pamplemousses", aliases: ["grand baie", "grand-baie", "pereybere", "péreybère", "trou aux biches", "mont choisy"] },
  { slug: "pamplemousses", label: "Pamplemousses", region: "Pamplemousses", aliases: ["pamplemousses", "triolet", "goodlands", "calebasses", "long mountain", "terre rouge"] },

  // Rivière du Rempart (district) — North-East
  { slug: "riviere-du-rempart", label: "Rivière du Rempart", region: "Rivière du Rempart", aliases: ["riviere du rempart", "rivière du rempart", "poudre d'or", "amaury", "petite riviere du rempart", "petite rivière du rempart", "roches noires", "saint antoine"] },

  // Flacq (district) — East
  { slug: "flacq", label: "Flacq", region: "Flacq", aliases: ["flacq", "centre de flacq", "belle mare", "trou d'eau douce", "poste de flacq", "lallmatie", "bel air"] },

  // Grand Port (district) — South-East
  { slug: "mahebourg", label: "Mahébourg", region: "Grand Port", aliases: ["mahebourg", "mahébourg", "plaine magnien", "blue bay", "vieux grand port"] },
  { slug: "grand-port", label: "Grand Port", region: "Grand Port", aliases: ["grand port", "grand-port", "bambous virieux", "rose belle", "rose-belle"] },

  // Savanne (district) — South
  { slug: "savanne", label: "Savanne", region: "Savanne", aliases: ["savanne", "souillac", "chemin grenier", "rivière des anguilles", "riviere des anguilles", "surinam"] },

  // Black River / Rivière Noire (district) — West
  { slug: "flic-en-flac", label: "Flic en Flac", region: "Black River", aliases: ["flic en flac", "flic-en-flac", "wolmar"] },
  { slug: "tamarin", label: "Tamarin", region: "Black River", aliases: ["tamarin", "black river", "rivière noire", "riviere noire", "bambous", "cascavelle", "le morne", "case noyale"] },
  { slug: "black-river", label: "Black River / Rivière Noire", region: "Black River", aliases: ["black river", "black-river", "rivière noire", "riviere noire"] },

  // Outer Islands
  { slug: "rodrigues", label: "Rodrigues", region: "Outer Islands", aliases: ["rodrigues", "port mathurin"] },
];
